import { createSlice } from "@reduxjs/toolkit";

const agentSlice = createSlice({
  name: "agents",
  initialState: {
    users: "",
  },

  reducers: {
    getAgentsList: (state, action) => {
      state.users = action.payload.users;
    },
  },
});

export const getAgentsList = agentSlice.actions.getAgentsList;
export default agentSlice.reducer;
